import React from "react";
import { Auth } from "redux-server-connection";
import DesafiosTabs from "../../components/DesafiosTabs";
import DesafiosDelMes from "./DesafiosDelMes";

import "./styles.css";

const constants = {
//  MONTH_NUMS: [1,2,3,4,5,6,7,8,9,10,11,12],
  INV_MONTH_NUMS: [12,11,10,9,8,7,6,5,4,3,2,1],
  MONTHS: ['-','Enero','Febrero','Marzo','Abril','Mayo','Junio','Julio','Agosto','Septiembre','Octubre','Noviembre','Diciembre']
}

function getPeriodTitle(period) {
  return constants.MONTHS[parseInt(period.toString().substr(4,2), 10)] + 
         ' - ' + 
         period.toString().substr(0,4);      
}

function getPeriodList(props) {
  var aux1 = props.goals.map(goal => {return (goal.period !== null ? goal.period.toString() : 0)});
  var aux2 = [];
  for (var i = 0; i < aux1.length; i++) {
    if (aux1[i]) {
      if (aux2.indexOf(aux1[i]) === -1) {
        aux2.push(aux1[i]);
      }
    }
  }
  aux2.sort();
  
  var periodList = [];
  for (var j = aux2.length - 1; j >= 0; j--) {
    periodList.push(aux2[j]);
  }
  
  return periodList;
}

const Render = (props, context) => {
  const loggedUser = Auth.getUser();
  var periodList = getPeriodList(props);

  return (
    <section>
       <div key="desafiosSect" className="desafios objetivos int pbxl">
        <div key="desafiosCont" className="container">
          <h1 key="desafiosTit" className="avenirBK violet horizontalCenter ">Desafíos</h1>
          <DesafiosTabs />
          {periodList.map(period => (
            <DesafiosDelMes key={period} id={period} period={period} periodo={getPeriodTitle(period)} 
                            user={loggedUser} 
                            mes={constants.MONTHS[parseInt(period.toString().substr(4,2), 10)]} 
                            goals={props.goals.filter(goal => {return goal.period === parseInt(period, 10);})} />
          ))}
        </div> 
      </div>
      <div className="leyenda pxl">
        {(!loggedUser.uy) && (
          <div className="">
            <p className="white">*1 Para el cumplimiento del objetivo "Venta Total UFS" forman parte todos los skus de la cartera de UFS.</p>
            <p className="white">*2 Para el cumplimiento del objetivo "Compradores Total UFS" forman parte todos los skus de la cartera de UFS.</p>
            <p className="white">*3 Para el cumplimiento del objetivo "Compradores Bolsas Premium UFS" forman parte la Mostaza Savora Original Bolsa 3 x 3kg; y los productos Hellmann's Mayonesa Alioli y Suave Bolsas 3 x 2,865 kg, Barbacoa Bolsa 3 x 3kg y Salsa Golf Bolsa 3 x 2,9kg.</p>
            <p className="white">*4 Para el cumplimiento del objetivo "Compradores Salsa Blanca Knorr" forman parte la Salsa Blanca Base Deshidratada 6 x 880g.</p>
          </div>
        )}
        {(loggedUser.uy) && (
          <div className="">
            <p className="white">*1 Para el cumplimiento del objetivo “Venta Sell Out“ forman parte del objetivo todos los skus de la cartera de UFS.</p>
            <p className="white">*2 Para el cumplimiento del objetivo “Compradores Salsas Base Knorr“ forma parte del objetivo los productos Knorr Salsa Blanca Bolsa 880g y Salsa Demi Glace 1kg.</p>
            <p className="white">*3 Para el cumplimiento del objetivo “Compradores Tomate en Polvo“ forman parte del objetivo el Tomate en Polvo Deshidratado Knorr 750g.</p>
            <p className="white">*4 Para el cumplimiento del objetivo “Compradores Sopas Crema“ forman parte del objetivo los productos Sopa CR Choclo Bolsa 600g, Zapallo Bolsa 690g, Verdura Bolsa 590g y Arveja c/Jamón Bolsa 630g.</p>
          </div>
        )}
      </div>
    </section>
    
  );
};
Render.contextTypes = {};

export default Render;



// WEBPACK FOOTER //
// ./src/pages/DesafiosObjetivos/Render.js